import React, { Component } from 'react';
import Column from './Column';
import TitleBar from './TitleBar';
import Row from './Row';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import { Map } from 'immutable';
import { TableContext } from './context';
const styles = {
  table: {
    tableLayout: 'fixed'
  },
  subHeader: {
    height: 1,
    backgroundColor: '#97a7bd',
    fontWeight: 'bold'
  },
  cell: {
    fontSize: 12,
    height: 30,
    whiteSpace: 'normal',
    textOverflow: 'initial',
    padding: '0px 24px'
  },
  paper: {
    margin: '0 6px 12px 6px'
  }
};
class FormTable extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      open: !this.props.children.get('IsCollapsible')
    };
    this.toggle = bool => {
      if (this.props.children.get('IsCollapsible')) {
        if (bool === undefined) {
          this.setState({
            open: !this.state.open
          });
        } else {
          this.setState({
            open: bool
          });
        }
      }
      return null;
    };
    this.renderTableBody = () => {
      return /*#__PURE__*/React.createElement(Collapse, {
        in: this.state.open
      }, /*#__PURE__*/React.createElement(Table, {
        className: this.props.classes.table,
        "data-testid": "FormTable-Table"
      }, /*#__PURE__*/React.createElement(TableBody, null, this.renderSubHeaders(), this.renderList())));
    };
  }
  renderSubHeaders() {
    const _this$props = this.props,
      children = _this$props.children,
      classes = _this$props.classes;
    let headerCells = [];
    let valuesFound = false;
    for (let i = 0; i < children.get('Headers').size; i++) {
      let value = children.getIn(['Headers', i, 'Value']);
      if (value) {
        valuesFound = true;
      }
      headerCells.push(/*#__PURE__*/React.createElement(TableCell, {
        key: i,
        className: classes.cell
      }, value));
    }
    if (valuesFound) {
      return /*#__PURE__*/React.createElement(TableRow, {
        className: classes.subHeader
      }, headerCells);
    }
    return null;
  }
  renderList() {
    const children = this.props.children;
    return children.get('Rows').map((row, i) => {
      if (row) {
        return /*#__PURE__*/React.createElement(Row, {
          key: i
        }, row);
      }
      return null;
    });
  }
  render() {
    const _this$props2 = this.props,
      children = _this$props2.children,
      classes = _this$props2.classes;
    const open = this.state.open;
    const context = {
      toggle: this.toggle,
      open
    };
    return /*#__PURE__*/React.createElement(TableContext.Provider, {
      value: context
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      "data-testid": "FormTable"
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 2,
      className: classes.paper
    }, /*#__PURE__*/React.createElement(TitleBar, {
      onClick: () => this.toggle(),
      collapsible: children.get('IsCollapsible'),
      open: open,
      "data-testid": "FormTable-Title"
    }, children.get('Name')), this.renderTableBody())));
  }
}
export default withStyles(styles)(FormTable);